<div *ngIf="view === 'icon'">
  <p-scrollPanel
    [id]="'drive-scroll-panel'"
    [styleClass]="
      'h-[calc(100dvh-var(--layout-header-height)-var(--page-header-height)-var(--drive-header-height))] faded-bottom'
    ">
    <div class="grid grid-cols-media gap-3 mb-[50px]">
      <div *ngFor="let data of combinedData; let i = index; trackBy: trackByIndex">
        @if (data.isPlaceholder) {
          @if (currentFolder?.parent_id) {
            <div class="flex flex-col justify-center items-center p-2 h-full w-full">
              <div
                class="mx-auto text-center cursor-pointer"
                (click)="selectedFolderId(currFolder)">
                <div><mat-icon class="big-icon" fontIcon="folder" /></div>
                <div>[...]</div>
              </div>
            </div>
          }
        }
        @if (data.type === 'album') {
          <offconon-media-folder-content-album-card
            [data]="data"
            [folderList]="folderList"
            [selectedAlbumId]="currentFolder"
            (selectedFolderEmit)="selectedFolderId($event)"
            (deleteFolderEmit)="deletedFolder($event)"
            (editedFolderEmit)="editedFolder($event)"
            (movedFolderEmit)="movedFolder($event)" />
        }
        @if (data.type === 'media') {
          <div
            class="media-gallery"
            [draggable]="true"
            (dragstart)="onDragStart($event, data)"
            (click)="toggleSelection(data.id || 0)">
            <offconon-media-folder-content-card
              [media]="data"
              [saveWithCrop]="saveWithCrop"
              [folderList]="folderList"
              (EditImageEmit)="editImage($event)"
              (ResetSelectedMediaEmmit)="resetSelected($event)" />
          </div>
        }
      </div>
    </div>
    <!--@if (
      (datas?.total_objects || 0) > pageSize &&
      loading === false &&
      (datas?.total_pages || 0) > page
    ) {
      <div #moreItem style="height: 50px; width: 100%"></div>
    }-->
    @if (
      (datas?.total_objects || 0) > pageSize &&
      loading === false &&
      (datas?.total_pages || 0) > page
    ) {
      <div #moreItem class="h-[50px] w-full"></div>
    }
    @if (
      (datas?.total_objects || 0) > pageSize && loading === false && datas?.total_pages === page
    ) {
      <div class="flex items-center justify-center">
        <p class="text-xs text-500 ml-1 pt-1 text-gray">{{ 'No more items' | translate }}</p>
      </div>
    }
    @if (loading) {
      <div class="flex justify-center items-center">
        <p-progressSpinner aria-label="Loading" [style]="{ height: '35px' }" />
      </div>
    }
    <div class="h-[50px] w-full"></div>
  </p-scrollPanel>
</div>
@if (view === 'list') {
  <div>
    <p-table
      size="small"
      responsiveLayout="stack"
      [scrollHeight]="tableHeight"
      [value]="combinedData"
      [tableStyle]="{ 'min-width': '20rem' }"
      [customSort]="true"
      [scrollable]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="46"
      (sortFunction)="onSort($event)">
      <ng-template #header>
        <tr>
          <th class="w-[40px]"></th>
          <th pSortableColumn="file_name">
            {{ 'Name' | translate }} <p-sortIcon field="file_name" />
          </th>
          <th pSortableColumn="file_size">
            {{ 'Size' | translate }} <p-sortIcon field="file_size" />
          </th>
          <th pSortableColumn="created_at">
            {{ 'Date' | translate }} <p-sortIcon field="created_at" />
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr
          *ngIf="item.isPlaceholder; else normalRow"
          class="cursor-pointer"
          (click)="selectedFolderId(currFolder)">
          <td class="text-center"></td>
          <td class="text-center">[...]</td>
          <td class="text-center"></td>
          <td class="text-center"></td>
        </tr>
        <ng-template #normalRow>
          <tr
            class="{{ item.selected ? 'text-primary' : '' }} cursor-pointer"
            [draggable]="true"
            (dragstart)="onDragStart($event, item)"
            (click)="item.type !== 'album' && toggleSelection(item.id || 0)"
            (click)="item.type === 'album' && selectedFolderId(item)">
            <td class="{{ item.selected ? 'text-primary' : 'text-gray' }}">
              @if (item.type !== 'album') {
                <i class="pi pi-{{ item.selected === true ? 'check-circle' : 'circle' }}"></i>
              }
            </td>
            <td class="{{ item.selected ? 'text-primary' : '' }} items-center">
              <offconon-list-menu-item
                [data]="item"
                [saveWithCrop]="saveWithCrop"
                [folderList]="folderList"
                [currentFolder]="currentFolder"
                (editedFolderEmit)="editedFolder($event)"
                (deleteFolderEmit)="deletedFolder($event)"
                (deletedIdEmit)="deletedId($event)" />
            </td>
            <td class="{{ item.selected ? 'text-primary' : 'text-gray' }} text-sm">
              <span *ngIf="item.file_size">
                {{ (item.file_size || 0) / 1000000 | number: '1.2-2' }} Mb
              </span>
            </td>
            <td class="{{ item.selected ? 'text-primary' : 'text-gray' }} text-sm">
              {{ item.created_at | date: 'short' }}
            </td>
          </tr>
        </ng-template>
      </ng-template>
    </p-table>
    <div class="flex flex-col">
      <div>
        @if (!results || results.length < 1) {
          <div>No media items available.</div>
        }
      </div>
    </div>
    @if (
      (datas?.total_objects || 0) > pageSize &&
      loading === false &&
      (datas?.total_pages || 0) > page
    ) {
      <div #moreItem class="h-[50px] w-full"></div>
    }
    @if (
      (datas?.total_objects || 0) > pageSize && loading === false && datas?.total_pages === page
    ) {
      <div class="flex items-center justify-center">
        <p class="text-xs text-500 ml-1 pt-1 text-gray">{{ 'No more items' | translate }}</p>
      </div>
    }
  </div>
}
